var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGithub = function SvgGithub(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Github_svg__a)",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 0H0v32h11.995c.002-.256.026-2.935.018-4.31-4.45.966-5.39-2.145-5.39-2.145-.728-1.848-1.777-2.34-1.777-2.34-1.452-.993.11-.973.11-.973 1.606.114 2.451 1.649 2.451 1.649 1.427 2.445 3.745 1.738 4.657 1.33.145-1.034.558-1.74 1.015-2.14-3.552-.403-7.288-1.776-7.288-7.907 0-1.747.624-3.175 1.647-4.294-.165-.404-.714-2.03.157-4.234 0 0 1.343-.43 4.4 1.64A15.324 15.324 0 0 1 16 7.738c1.359.006 2.728.184 4.006.538 3.055-2.07 4.395-1.64 4.395-1.64.874 2.203.325 3.83.16 4.234 1.025 1.12 1.645 2.547 1.645 4.294 0 6.146-3.741 7.499-7.306 7.895.575.494 1.086 1.47 1.086 2.963 0 1.918.018 5.673.02 5.978H32V0Z",
    fill: "#434343"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.995 32.02s.026-2.885.018-4.33c-4.45.966-5.39-2.145-5.39-2.145-.728-1.848-1.777-2.34-1.777-2.34-1.452-.993.11-.973.11-.973 1.606.114 2.451 1.649 2.451 1.649 1.427 2.445 3.745 1.738 4.657 1.33.145-1.034.558-1.74 1.015-2.14-3.552-.403-7.288-1.776-7.288-7.907 0-1.747.624-3.175 1.647-4.294-.165-.404-.714-2.03.157-4.234 0 0 1.343-.43 4.4 1.64A15.324 15.324 0 0 1 16 7.738c1.359.006 2.728.184 4.006.538 3.055-2.07 4.395-1.64 4.395-1.64.874 2.203.325 3.83.16 4.234 1.025 1.12 1.645 2.547 1.645 4.294 0 6.146-3.741 7.499-7.306 7.895.575.494 1.086 1.47 1.086 2.963 0 2 .02 5.998.02 5.998h-8.011Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Github_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#fff"
  })))));
};
export default SvgGithub;